import React from 'react';
import { Grid, Box } from '@mui/material';
import { ErrorMessage } from '@hookform/error-message';
import { US_STATES_ARRAY } from '../../../../constants/common';
import { MUIFormTextInput } from '../TextInput/FormTextInput';
import { MUIFormSelectInput } from '../SelectInput/FormSelectInput';

const AddressForm = ({ control, errors, isRequired = false }) => {
    return (
        <>
            <Grid container sx={{ marginBottom: '16px' }}>
                <Grid item xs={12}>
                    <MUIFormTextInput
                        control={control}
                        name="locationName"
                        label="Location Name"
                        gxid="locationName"
                    />
                </Grid>
            </Grid>
            <Grid container sx={{ marginBottom: '16px' }}>
                <Grid item xs={12}>
                    <MUIFormTextInput
                        control={control}
                        rules={{
                            pattern: {
                                value: /^(?!.*[.,' -]{2})(?!.*[,' -]$)(?!^[,' -])(?!.*\s{2,})[a-zA-Z0-9][a-zA-Z0-9 .,\'-]*[a-zA-Z0-9.]$/,
                            },
                            required: isRequired ? { value: true, message: 'Address is required' } : false,
                        }}
                        hideErrorMessage
                        name="address"
                        label="Address"
                        gxid="address"
                    />
                    <Box>
                        <ErrorMessage
                            errors={errors}
                            name="address"
                            render={() => (
                                errors.address?.type === 'pattern' ?
                                    <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                        This field contains invalid characters.
                                    </p>
                                    :
                                    <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                        Address is required.
                                    </p>
                            )}
                        />
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginBottom: '16px', minHeight: '58px' }}>
                <Grid item xs={6}>
                    <MUIFormTextInput
                        control={control}
                        rules={{
                            pattern: {
                                value: /^(?!.*[.,' -]{2})(?!.*[,' -]$)(?!^[,' -])(?!^\s)(?!.*\s$)[a-zA-Z0-9][a-zA-Z0-9 .,\'-]*[a-zA-Z0-9]$/,
                            },
                            required: isRequired ? { value: true, message: 'City is required' } : false,
                        }}
                        hideErrorMessage
                        name="city"
                        label="City"
                        gxid="city"
                    />
                    <Box>
                        <ErrorMessage
                            errors={errors}
                            name="city"
                            render={() => (
                                errors.city?.type === 'pattern' ?
                                    <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                        This field contains invalid characters.
                                    </p>
                                    :
                                    <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                        City is required.
                                    </p>
                            )}
                        />
                    </Box>
                </Grid>
                <Grid item xs={2}>
                    <MUIFormSelectInput
                        name="state"
                        control={control}
                        label="State"
                        items={US_STATES_ARRAY}
                        gxid="createCodePoolcodeLimitType"
                        hideErrorMessage
                        rules={{
                            required: isRequired ? { value: true, message: 'State is required' } : false,
                        }}
                    />
                    <Box>
                        <ErrorMessage
                            errors={errors}
                            name="city"
                            render={() => (
                                <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                    State is required.
                                </p>
                            )}
                        />
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <MUIFormTextInput
                        control={control}
                        rules={{
                            pattern: { value: /^(\d{5})?$/ },
                            maxLength: 5,
                            required: isRequired ? { value: true, message: 'Zip code is required' } : false
                        }}
                        type="number"
                        maxLength={5}
                        name="zipCode"
                        label="Zip Code"
                        gxid="eventZip"
                        hideErrorMessage
                        styles={{
                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                display: 'none',
                            },
                            '& input[type=number]': {
                                MozAppearance: 'textfield',
                            },
                        }}
                    />
                    <Box>
                        <ErrorMessage
                            errors={errors}
                            name="zipCode"
                            render={() => (
                                errors.zipCode?.type === 'maxLength' ?
                                    <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                        Zip code must be a 5-digit number.
                                    </p>
                                    :
                                    <p style={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
                                        Zip code is required.
                                    </p>
                            )}
                        />
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default AddressForm;